/**
 * Created by user on 2020/5/11.
 */

export * from '@novel-segment/loader-stopword';
import load from '@novel-segment/loader-stopword';

export default load
